module.exports = __webpack_public_path__ + "img/392066e.jpg";